import { TableCell, TableRow, Typography } from '@mui/material';

export const CourseLeaderBoardTableRow = ({ row, index, actions }) => {
  const { name, userLevel, info, score, finishedCourses } = row;

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography variant="body2">{index + 1}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={700}>
            {name || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body2" fontWeight={400}>
            {userLevel?.levelName || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {info?.mobile || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {finishedCourses || '-'}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {score || '-'}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
};
